import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ExternalLink } from 'lucide-react';

import { BACKEND_URL } from '../config';

const OurCreationsSection = () => {
  const [creations, setCreations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCreations();
  }, []);

  const fetchCreations = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/creations?published_only=true`);
      setCreations(response.data);
    } catch (error) {
      console.error('Failed to fetch creations:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Creations</h2>
          <div className="w-24 h-1 bg-[#0d6571] mx-auto mb-4"></div>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Discover our successful projects and innovative solutions
          </p>
        </div>

        {loading ? (
          <div className="text-center py-12">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#0d6571]"></div>
          </div>
        ) : creations.length === 0 ? (
          <div className="text-center py-12 text-gray-500">
            No creations available yet.
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {creations.map((creation, index) => (
              <div
                key={creation.id}
                className="group relative bg-gradient-to-br from-[#0d6571] to-[#0d6571]/80 rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1"
              >
                {/* Background Pattern */}
                <div className="absolute inset-0 opacity-10">
                  <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full blur-3xl transform translate-x-32 -translate-y-32"></div>
                  <div className="absolute bottom-0 left-0 w-64 h-64 bg-white rounded-full blur-3xl transform -translate-x-32 translate-y-32"></div>
                </div>

                <div className="relative p-8">
                  {/* Badge */}
                  <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full mb-4">
                    <span className="text-white text-xs font-semibold">Case Study #{index + 1}</span>
                  </div>

                  {/* Title */}
                  <h3 className="text-2xl font-bold text-white mb-4">
                    {creation.title}
                  </h3>

                  {/* Description */}
                  <p className="text-white/90 mb-6 leading-relaxed">
                    {creation.description}
                  </p>

                  {/* Button */}
                  <a
                    href={creation.buttonLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 bg-white text-[#0d6571] px-6 py-3 rounded-full font-semibold hover:bg-gray-100 transition-all duration-300 group-hover:scale-105"
                  >
                    {creation.buttonText}
                    <ExternalLink className="w-4 h-4" />
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default OurCreationsSection;
